import { render } from "./TestScreenSize.vue?vue&type=template&id=30a4bccd"
import script from "./TestScreenSize.vue?vue&type=script&lang=js"
export * from "./TestScreenSize.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__